import { THEME_PREFERENCES, useThemeStore } from '@ctcells/core'
import { t, type MessageKey } from '@ctcells/i18n'

import './themeToggle.css'

/**
 * 테마 전환 — 3분기(시스템 · 라이트 · 다크). 목록의 출처는 `THEME_PREFERENCES` 한 곳이다.
 *
 * 🔴 **설정 화면이 없는 표면 전용이다.** 콘솔은 「내 계정 › 개인 설정」으로 옮겼고, 여기 남은 것은
 *    모듈 패드 3종 헤더와 태블릿 kiosk 머리줄이다. 둘 다 싣는 화면에 설정이 없다 —
 *    패드는 무인증 현장 장비이고, 태블릿은 3종(모니터링 · 작업 · 알람) 축약형이다.
 *    거기서 이걸 빼면 그 표면에서는 테마를 바꿀 방법이 사라진다. **지우지 마라.**
 *
 * 왜 2분기 토글이 아니라 3분기인가: '시스템' 을 고를 수 있어야
 * 사용자가 "덮어쓰기를 풀고 OS 를 따라간다"를 표현할 수 있다.
 */
export function ThemeToggle() {
  const preference = useThemeStore((s) => s.preference)
  const setPreference = useThemeStore((s) => s.setPreference)

  return (
    <div className="themetog" role="radiogroup" aria-label={t('theme.label')}>
      {THEME_PREFERENCES.map((value) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={preference === value}
          className="themetog__opt"
          onClick={() => setPreference(value)}
        >
          {t(`theme.${value}` as MessageKey)}
        </button>
      ))}
    </div>
  )
}
